<template>
  <div class="container">
    <!-- 头部部分 -->
    <div class="top_box">
      <!-- 头部搜索框 -->
      <div class="search">
        <input type="text" class="search_key" :placeholder="hold" v-model="searchkey" />
        <span class="search_btn" @click="startSearch">查询</span>
        <img src="../../../../assets/image/search.png" class="search_img" />
      </div>
      <!-- 筛选功能 -->
      <div class="search_query">
        <div class="item" @click="showCity">
          <span class="city" >{{md.cityPickerValue}}</span>
          <img src="../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showType">
          <span class="city">{{md.typePickerValue}}</span>
          <img src="../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showTime">
          <span class="city">{{md.datePickerValue}}</span>
          <img src="../../../../assets/image/jiantou.png" class="jian" />
        </div>
      </div>
    </div>
    <van-list
      ref="vanList"
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="onLoad"
      class="wrapper"
    >
      <div
        class="reject"
        v-for="(item,index) in proList"
        :key="index"
        @click="goDetail(item.flowId)"
      >
        <div class="reject_item">
          <p class="title_text">{{item.product}}</p>
          <div class="info">
            <p>所属区域：</p>
            <p>{{item.geography}}</p>
          </div>
          <div class="info">
            <p>商家名称：</p>
            <p>{{item.shoppingStore}}</p>
          </div>
          <div class="info">
            <p>退货人：</p>
            <p>{{item.purchaser}}</p>
          </div>
          <div class="info">
            <p>商品金额：</p>
            <p>¥{{item.shoppingAmount}}</p>
          </div>
          <div class="info">
            <p>商品类型：</p>
            <p>{{item.productType|filt1}}</p>
          </div>
          <div class="info">
            <p>退货时间：</p>
            <p>{{item.refundTime|filt()}}</p>
          </div>
          <div class="info">
            <p>退货单号：</p>
            <p>{{item.orderNumber}}</p>
          </div>
          <div class="line line_bottom"></div>
          <div class="status">
               <span class="left">{{item.centerName}}-{{item.statusText}}</span>
               <div class="right">
                     <span>查看详情</span>
                     <img src="../../../../assets/image/right.png"/>
               </div>
          </div>
        </div>
      </div>
    </van-list>
        <noContent v-if="isNolist" class="noBox"></noContent>
        <common-picker ref="commonPicker1" :typeList="typeList1" :cols="cols1" @getTypeValue="getCityValue" :isShowAbountButton="false"></common-picker>
        <common-picker ref="commonPicker2" :typeList="typeList2" :cols="cols2" @getTypeValue="getTypeValue" :isShowAbountButton="false"></common-picker>
        <common-picker ref="commonPicker3" :typeList="typeList3" :cols="cols3" @getTypeValue="getValue" :isShowAbountButton="true"  @showRangTime="showRangTime"></common-picker>
        <rang-time ref="rangsTime" @closeRangTime="closeRangTime" v-if="ishowRangeTime"></rang-time>
  </div>
</template>
<script>
    import moment from 'moment';
    import commonPicker from '../../../../components/base/commonPicker'
    import noContent from '../components/baseComponent/noContent'
    import api from '../../../../service/modules/refund';
    import { formateYear, timeType2 } from '../../../../utils/configJson'
    import util from '../../../../utils/common';
    import rangTime from '../../../../components/rangTime'
    import apimessage from '../../../../service/modules/message'
    export default {
        components: {
            commonPicker,
            noContent,
            'rang-time': rangTime
        },
        name: 'manageList',
        data () {
            return {
                ishowRangeTime: false,
                title: '退货列表',
                md: {
                    datePickerValue: '筛选时间',
                    typePickerValue: '退货渠道',
                    cityPickerValue: '州市-县区',
                    cityCode: '',
                    typeCode: ''
                },
                searchkey: '', // 搜索的ke值
                pickerValue: '',
                isPicker: false,
                currentDate: new Date(),
                pageIndex: '0',
                pageSize: '10',
                proList: [], // 列表
                isNolist: false, // 没有内容的状态
                isload: true, // 底部加载中的状态
                message: '加载中...',
                bottomStatus: '',
                cityList: [],
                userInfo: this.$store.state.userInfo || JSON.parse(localStorage.getItem('refundUserInfo')),
                isHide: false,
                isShow: false,
                startTime: this.$router.currentRoute.query.day || '',
                endTime: this.$router.currentRoute.query.day || '',
                ishowRangeTime: false,
                status: this.$router.currentRoute.query.status,
                refundType: this.$router.currentRoute.query.refundType,
                isCenterReceipt: this.$router.currentRoute.query.isCenterReceipt,
                cover: this.$router.currentRoute.query.cover,
                typeList1: [],
                cols1: 2,
                typeList2: [],
                cols2: 1,
                typeList3: timeType2,
                cols3: 3,
                citypick: '',
                hold: '退货单号/退货商家/退货人姓名',
                loading: true,
                finished: false,
                scrollY: 0,
                timer: null,
                regionCode: '',
                finishedText: '没有更多'
                // aboutText:''
            };
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            // this.typeList3 = formateYear(timeType)
            this.regionCode = this.userInfo.regionCode;
            this.md.cityPickerValue = this.userInfo.regionName;
            this.md.cityCode = this.regionCode;
            this.getAllCity();

            // jsb直接跳转configList拉取数据
            if (localStorage.getItem('configList')) {
                this.getType();
            } else {
                this.getTypeConf()
            }
            if (this.md.cityCode !== '') {
                this.getList()
            }
        },
        mounted () {
        },
        activated () {
            this.searchkey = '';
            this.hold = '退货单号/退货商家/退货人姓名';
            this.status = this.$router.currentRoute.query.status;
            this.refundType = this.$router.currentRoute.query.refundType;
            this.isCenterReceipt = this.$router.currentRoute.query.isCenterReceipt;
            this.cover = this.$router.currentRoute.query.cover;
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例
                if (from.path === '/refund/worker' || from.path === '/index') {
                    // 一定是从A进到B页面才刷新
                    vm.proList = [];
                    vm.isNolist = false;
                    vm.loading = true;
                    vm.finished = false;
                    vm.md.datePickerValue = '筛选时间';
                    vm.md.typePickerValue = '退货渠道';
                    // vm.md.cityPickerValue = '州市-县区';
                    vm.startTime = '';
                    vm.endTime = '';
                    // vm.md.cityCode = '';
                    vm.md.typeCode = '';
                    vm.pageIndex = '1';
                    vm.searchkey = '';
                    vm.hold = '退货单号/退货商家/退货人姓名';
                    vm.getList();
                } else {

                }
            });
        },
        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            getTypeConf () {
                // 获取配置中心数据
                api.typePicker({}).then(res => {
                    if (res.ret === 0) {
                        // this.$store.state.configlist = res.data;
                        util.setJsonLocal('configList', res.data);
                        this.getType();
                    }
                });
            },
            showRangTime () {
                setTimeout(() => {
                    this.ishowRangeTime = true;
                }, 500)
            },
            goDetail (value) {
                this.$store.state.refund.flowId = value;
                util.setJsonLocal('flowId', value);
                this.$router.push('refundDetail?flowId=' + value);
            },
            getType () {
                this.typeList2 = []
                var type = util.getJsonLocal('configList').REFUND_CHANNEL;
                let list = [];
                type.map((item, index) => {
                    list.push({ text: item.name, value: index, code: item.code });
                });

                this.typeList2.push(list);
                this.cols2 = 1
            },
            showCity () {
                this.$refs.commonPicker1.showPicker();
            },
            showType () {
                this.$refs.commonPicker2.showPicker();
            },
            showTime () {
                // this.typeList3=[];
                this.typeList3 = timeType2;
                this.$refs.commonPicker3.showPicker();
            },
            openTime1 () {
                setTimeout(() => {
                    this.ishowRangeTime = true;
                }, 500);
            },
            closeRangTime (value) {
                console.log('value:', value)
                if (value) {
                    this.startTime = value[0];
                    this.endTime = value[1];
                    this.md.datePickerValue = value[2];
                    this.getList();
                    this.ishowRangeTime = false;
                } else {
                    this.ishowRangeTime = false;
                }
            },
            getValue (value) {
                // if (value[0].key === 'year') { // 年份
                //     this.md.datePickerValue = value[1].text + '年';
                //     this.startTime = value[1].value1;
                //     this.endTime = value[1].value2;
                //     console.log(this.startTime);
                //     console.log(this.endTime);
                // } else if (value[0].key === 'quarter') {
                //     this.md.datePickerValue = new Date().getFullYear() + value[1].text;
                //     this.startTime = new Date().getFullYear() + '-' + value[1].value1;
                //     this.endTime = new Date().getFullYear() + '-' + value[1].value2;
                // } else if (value[0].key === 'mouth') {
                //     this.md.datePickerValue = new Date().getFullYear() + '年' + value[1].text;
                //     const d = new Date((new Date()).getFullYear(), value[1].value1, 0)// 获取当月的天数
                //     this.startTime = (new Date()).getFullYear() + '-' + value[1].value1 + '-01';
                //     this.endTime = (new Date()).getFullYear() + '-' + value[1].value1 + '-' + d.getDate();
                // }
                if (value[1].key === 'year') {
                    this.md.datePickerValue = value[0].value;
                    this.startTime = value[0].value + '-' + value[1].value1;
                    this.endTime = value[0].value + '-' + value[1].value2;
                } else if (value[1].key === 'quarter') {
                    this.md.datePickerValue = value[0].value + '年' + value[2].text;
                    this.startTime = value[0].value + '-' + value[2].value1;
                    this.endTime = value[0].value + '-' + value[2].value2;
                } else if (value[1].key === 'moutn') {
                    this.md.datePickerValue = value[0].value + '年' + value[2].value1 + '月';
                    const d = new Date((new Date()).getFullYear(), value[2].value1, 0)// 获取当月的天数
                    this.startTime = value[0].value + '-' + value[2].value1 + '-01';
                    this.endTime = value[0].value + '-' + value[2].value1 + '-' + d.getDate();
                }
                this.getList();
            },
            getTypeValue (value) {
                console.log(123, value)
                this.md.typeCode = value[0].code;
                this.md.typePickerValue = value[0].text;
                this.getList();
            },
            getCityValue (value) {
                if (value.length > 1) {
                    this.md.cityPickerValue = value[0].label + '-' + value[1].label;
                    this.md.cityCode = value[1].value;
                } else {
                    this.md.cityPickerValue = value[0].label;
                    this.md.cityCode = value[0].value;
                }
                this.getList();
            },
            getTimeValue (value) {
                this.md.datePickerValue = value;
            },
            startSearch () {
                if (this.searchkey.trim().length === 0) {
                    this.md.datePickerValue = '筛选时间';
                    this.md.typePickerValue = '退货渠道';
                    // this.md.cityPickerValue = '州市-县区';
                    this.md.cityPickerValue = this.userInfo.regionName;
                    this.startTime = '';
                    this.endTime = '';
                    // this.md.cityCode = '';
                    this.md.cityCode = this.userInfo.regionCode;
                    this.md.typeCode = '';
                    this.pageIndex = '1';
                    this.searchkey = '';
                    this.getList();
                    //   Toast({
                    //       message:'搜索条件不能为空~'
                    //   })
                } else {
                    // 调去搜索的接口,重置所有的搜索条件
                    this.md.datePickerValue = '筛选时间';
                    // this.md.cityPickerValue = '州市-县区';
                    this.md.cityPickerValue = this.userInfo.regionName;
                    this.md.typeCode = '';
                    this.pageIndex = '1';
                    this.getList();
                }
            },
            getList () {
                this.proList = [];
                this.pageIndex = 1;
                // this.finished = false;
                // this.loading = true;
                let city;
                let type;
                if (this.md.cityPickerValue === '州市-县区') {
                    city = '';
                } else {
                    city = this.md.cityPickerValue;
                }
                console.log('this.startTime:', this.startTime)
                console.log('this.endTime:', this.endTime)
                api
                    .returnList({
                        startDate: this.startTime,
                        endDate: this.endTime,
                        refundChannel: this.md.typeCode,
                        areaId: this.md.cityCode,
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        searchStr: this.searchkey,
                        status: this.status,
                        refundType: this.refundType,
                        isCenterReceipt: this.isCenterReceipt,
                        cover: this.cover
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            console.log('退货返回列表：', res.data.list)
                            if (res.data.list.length > 0) {
                                this.proList = res.data.list;
                                if (this.proList.length === res.data.pageination.total) {
                                    this.finished = true;
                                    this.loading = false;
                                    this.isNolist = false;
                                } else {
                                    this.finished = false;
                                    this.loading = false;
                                    this.isNolist = false;
                                }
                            } else {
                                this.finished = true;
                                this.loading = false;
                                this.isNolist = true;
                                this.finishedText = '';
                            }
                        }
                    });
            },
            getMore () {
                console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<,,,,1')
                let city;
                let time;
                if (this.md.cityPickerValue === '州市-县区') {
                    city = '';
                } else {
                    city = this.md.cityPickerValue;
                }
                api
                    .returnList({
                        startDate: this.startTime,
                        endDate: this.endTime,
                        refundChannel: this.md.typeCode,
                        areaId: this.md.cityCode,
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        isCenterReceipt: this.isCenterReceipt,
                        status: this.status,
                        refundType: this.refundType,
                        cover: this.cover,
                        searchStr: this.searchkey
                    })
                    .then(res => {
                        // setTimeout(() => {
                        if (res.data.list.length > 0) {
                            this.proList = this.proList.concat(res.data.list);
                            if (this.proList.length === res.data.pageination.total) {
                                this.finished = true;
                                this.loading = false;
                            } else {
                                this.finished = false;
                                this.loading = false;
                            }
                        } else {
                            this.finished = true;
                            this.loading = false;
                        }
                        // }, 500);
                    });
            },
            getAllCity () { // 获取所有的市
                api.getCity({ 'regionCode': this.regionCode }).then((res) => {
                    var list = res.data[0];
                    let city = [];
                    if (list.regionType === 1) { // 多个市
                        if (list.children != null) {
                            this.cols1 = 2;
                            var obj = { 'value': list.code,
                                        'label': list.name,
                                        'children': [
                                            { 'value': '530000', 'label': '全部', 'children': [] }
                                        ] };
                            // city.push(obj);
                            list.children.map((item, index) => {
                                // obj1.children.push({ 'value': item.code, 'label': item.name, 'children': [] });
                                const obj1 = { 'value': item.code,
                                               'label': item.shortName,
                                               'children': [
                                               ] };
                                if (item.children) {
                                    item.children.map((item1, index1) => {
                                        obj1.children.push({ 'value': item1.code, 'label': item1.shortName, 'children': [] });
                                    })
                                }
                                city.push(obj1);
                            })
                            city.unshift(obj);
                        } else {
                            city.push({ 'value': list.code, 'label': list.name, 'children': [] })
                            this.cols1 = 1
                        }
                    } else { // 一个市
                        if (list.children != null) {
                            this.cols1 = 2;
                            var obj = { 'value': list.code,
                                        'label': list.name,
                                        'children': [
                                            { 'value': list.code, 'label': '全部', 'children': [] }
                                        ] };
                            list.children.map((item, index) => {
                                obj.children.push({ 'value': item.code, 'label': item.name, 'children': [] });
                            })
                            city.push(obj);
                        } else {
                            city.push({ 'value': list.code, 'label': list.name, 'children': [] })
                            this.cols1 = 1;
                        }
                    }
                    console.log(city);
                    this.typeList1 = [];
                    this.typeList1.push(city);
                    setTimeout(() => {
                        this.$refs.commonPicker1._initFresh();
                    }, 50)
                })
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            },
            handleTopChange (status) {
                this.bottomStatus = status;
            },
            loadBottom () {
                this.getMore();
            },
            loadTop () {
                this.$refs.loadmore.onTopLoaded();
            }
        },
        beforeDestroy () {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            }
        }
    };
</script>
<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
  .top_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: #fff;
    .search {
      width: 100%;
      position: relative;
      margin-top: 10px;
      .search_key {
        width: 297px;
        height: 36px;
        background: #f8f8f8;
        border-radius: 3px;
        margin-left: 15px;
        font-size: 13px !important;
        padding-left: 39px;
        box-sizing: border-box;
        border: 0;
        outline: none;
        line-height: 36px;
      }
      .search_btn {
        font-size: 14px;
        margin-left: 16px;
      }
      .search_img {
        width: 15px;
        height: 14px;
        position: absolute;
        left: 30px;
        top: 11px;
      }
    }
    .search_query {
      width: 100%;
      height: 42px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      -webkit-flex-direction: row;
      .item {
        flex: 1;
        text-align: center;
        line-height: 42px;
        .city {
          display: inline-block;
          vertical-align: middle;
          font-size: 12px;
          color: #666;
          max-width: 110px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .jian {
          width: 6px;
          height: 4px;
          display: inline-block;
          vertical-align: middle;
          margin-left: 5px;
        }
      }
    }
  }
  .wrapper {
    width: 100%;
    padding-top: 88px;
    .reject {
      width: 100%;
      .reject_item {
        margin: 24px 12px 0 12px;
        box-sizing: border-box;
        background-color: #fff;
        padding: 16px 16px 0 16px;
        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .title_text {
          font-size: 16px;
          font-weight: 700;
          color: #2a2a2a;
          padding-bottom: 4px;
        }
        .info {
          margin-top: 12px;
          display: flex;
          p:nth-child(1) {
            width: 25%;
            font-size: 14px;
            color: #999999;
            line-height: 18px;
          }
          p:nth-child(2) {
            width: 80%;
            font-size: 14px;
            line-height: 18px;
            color: #999999;
          }
        }
        .line {
          width: 100%;
          height: 1px;
          margin-top: 16px;
        }
        .status {
          width: 100%;
          padding-top: 15px;
          padding-bottom: 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: space-between;
          align-items: center;
          .left{
            font-size:14px;
            color:#333;
          }
          .right{
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            align-items: center;
            img{
              width:4px;
              height:7px;
              margin-left:6px;
            }
            span{
               font-size:12px;
               color:#999;

            }
          }

        }
      }
      .space {
        width: 100%;
        height: 4px;
        background-color: #eee;
      }
    }
  }
  .animate_active {
    animation: changehide 1s ease-out forwards;
  }
  .animate_active1 {
    animation: changehide1 1s ease-out backwards;
  }
  .noBox {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
  @keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @-webkit-keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @keyframes changehide1 {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @-webkit-keyframes changehid1 {
    0% {
      opacity: 0.8;
      right: -35px;
    }
    100% {
      opacity: 1;
      right: 0;
    }
  }
  .go_home {
    position: fixed;
    right: 0;
    top: 538px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="less">
.mint-loadmore-bottom {
  span {
    display: inline-block;
    transition: 0.2s linear;
    vertical-align: middle;
    .rotate {
      transform: rotate(180deg);
    }
  }
}
</style>
